import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { JobCardComponent } from './job-card.component';
import { RouterModule } from '@angular/router';
import { JobCardAddressGroupPipe } from './pipes/job-card-address-group.pipe';
import { JobCardTimedifPipe } from './pipes/job-card-timedif.pipe';

@NgModule({
  declarations: [
    JobCardComponent,
    JobCardAddressGroupPipe,
    JobCardTimedifPipe
  ],
  imports: [
    RouterModule,
    CommonModule
  ],
  exports: [
    JobCardComponent
  ]
})
export class JobCardModule { }
